<template>
    <div class="mask-care-container">
      <!-- 主要標題 (全寬) -->
      <h1>面膜小知識</h1>
  
      <!-- 副標題 & 圖片 -->
      <div class="subtitle-and-image">
        <!-- 文字: 從左到右淡入 -->
        <h2 class="text-animation">該如何選擇面膜？</h2>
  
        <!-- 圖片: 從右到左淡入 -->
        <img
          class="image-float-right image-animation"
          v-lazy="{ src: imagePath('maskCare.webp') }"
          :alt="`${$COMPANY_NAME} (${$COMPANY_NAMEn}) 面膜小知識！`"
        />
      </div>
  
      <!-- 以下文字也想套用 從左到右淡入，可以加上 .text-animation -->
      <p class="text-animation">
        選擇面膜時，您應該考慮以下幾個關鍵因素，以確保選擇最適合您的面膜：
      </p>

      <!-- 條列說明，一併加入 text-animation -->
      <ol class="text-animation">
        <li>
          <strong>膚質和需求：</strong>
          首先，了解您的膚質和皮膚需求是至關重要的。不同的面膜配方適合不同的膚質，例如，有些面膜適合干性皮膚，而其他面膜適合油性皮膚或敏感性皮膚。確保選擇的面膜能夠解決您的特定皮膚問題，如保濕、抗衰老、清潔毛孔等。
        </li>
        <li>
          <strong>成分：</strong>
          仔細檢查面膜的成分列表。一些常見的皮膚友好成分包括透明質酸、維生素C、維生素E、維生素B5、燕麥、綠茶、薰衣草等。選擇具有您感興趣成分的面膜。
        </li>
        <li>
          <strong>品牌和信譽：</strong>
          選擇知名品牌的面膜，或者參考其他消費者的評論和評價，以確保質量和信譽。不要輕信號稱可以解決所有皮膚問題的便宜面膜。
        </li>
        <li>
          <strong>用途：</strong>
          考慮您的面膜的用途。有些面膜可以定期使用，而其他面膜可能是一次性或特殊療程。確保您理解面膜的使用頻率和方法。
        </li>
        <li>
          <strong>敏感性測試：</strong>
          如果您有敏感皮膚，最好在使用面膜之前進行敏感性測試，以確保不會引起皮膚不適或過敏反應。在耳後或下巴上塗抹一小部分面膜，觀察是否有不良反應。
        </li>
        <li>
          <strong>價格：</strong>
          面膜價格範圍廣泛。確保您的選擇在您的預算範圍內，但也不要只選擇價格最低的選項，因為質量可能會受到影響。
        </li>
        <li>
          <strong>專業建議：</strong>
          如有需要，咨詢皮膚科醫生或美容專家的建議。他們可以根據您的皮膚類型和需求提供定制建議。
        </li>
      </ol>
  
      <!-- 結語段落，一樣加入 text-animation -->
      <p class="text-animation">
        選擇面膜是一個根據個人需求和皮膚特質的過程。仔細研究產品，了解自己的皮膚，並在購買前考慮以上因素，有助於確保您選擇的面膜能夠最大程度地滿足您的需求，同時確保皮膚的健康和美麗。
      </p>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'MaskCarePage',
    computed: {
      ...mapGetters(['imagePath']),
    },
    mounted() {
      // IntersectionObserver: 當元素進入視口時，將其淡入
      const observerOptions = { threshold: 0.1 };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, observerOptions);
  
      // 監聽文字(左->右) 元素
      const textEls = this.$el.querySelectorAll('.text-animation');
      textEls.forEach((el) => observer.observe(el));
  
      // 監聽圖片(右->左) 元素
      const imgEl = this.$el.querySelector('.image-animation');
      if (imgEl) {
        observer.observe(imgEl);
      }
    }
  };
  </script>
  
  <style scoped>
  .mask-care-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    line-height: 1.6;
  }
  
  /* 包住副標題 + 浮動圖片的容器 */
  .subtitle-and-image {
    position: relative; 
    margin-bottom: 1rem;
  }
  
  /* 讓圖片浮動在右側 */
  .image-float-right {
    float: right;
    width: 300px;      /* 圖片寬度可依需求調整 */
    max-width: 50%;    /* 不超過容器一半 */
    height: auto;
    margin-left: 20px; 
    margin-bottom: 10px; 
    margin-top: 0.3rem; 
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    object-fit: cover;
    border-radius: 15px; /* 圆角效果 */
    border: 5px solid #fff; /* 添加白色边框 */
    transition: transform 0.3s ease, box-shadow 0.3s ease; /* 滑鼠懸停特效 */
  }
  
  /* 響應式，小螢幕時取消 float，避免壓縮文字 */
  @media (max-width: 768px) {
    .image-float-right {
      float: none;
      display: block;
      margin: 0 auto 20px;
      width: 100%;
      max-width: 100%;
    }
  }
  
  /* 主要標題 */
  .mask-care-container h1 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
  
  /* 副標題 */
  .subtitle-and-image h2 {
    font-size: 1.4rem;
    margin: 0 0 0.5rem;
  }
  
  /* 列表樣式 */
  ol {
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
  
  ol li {
    margin-bottom: 1rem;
  }
  
  /* ----------------------------
     動畫：文字(左->右)，圖片(右->左)
  ----------------------------- */
  
  .text-animation {
  opacity: 0;
  transform: translateX(-50px) scale(0.8);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.text-animation.visible {
  opacity: 1;
  transform: translateX(0) scale(1);
}
  
  /* 圖片(右->左) 初始位置 */
  .image-animation {
    opacity: 0;
  transform: translateX(50px) scale(0.8);
  transition: opacity 0.8s ease, transform 0.8s ease;
  }
  
  /* 圖片進入視口後 -> 淡入至原點 */
  .image-animation.visible {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
  </style>
  